import api from '@/utils/httpClient';
import serviceUrls from '@oncolens/oncolens-ui/lib/api/service-urls';
import { ApiResponse } from '@oncolens/oncolens-ui/lib/dto/api/ApiResponse';
import { useQuery } from 'react-query';
import { UserProfileDto, UserProfileForManipulation } from '../dto/userprofile';
import { UserProfileKeys } from './userprofile.keys';

const baseUrl = serviceUrls.ADMIN();

function getUserProfile() {
  return api
    .get(`${baseUrl}/api/userprofiles/bytoken`)
    .then((response) => (response.data as ApiResponse<UserProfileDto>).data);
}

function useGetUserProfile() {
  return useQuery(['admin', 'userprofile'], () => getUserProfile(), {
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    retry: false
  });
}

function createUserProfile(data: UserProfileForManipulation) {
  return api
    .post(`${baseUrl}/api/userprofiles`, data)
    .then((response) => (response.data as ApiResponse<UserProfileForManipulation>).data);
}

export const getSpecialtiesList = async () => {
  const response = await api.get(`${baseUrl}/api/userprofiles/specialties`);
  return response.data as string[];
};

export const useGetSpecialtiesList = () =>
  useQuery(UserProfileKeys.specialties(), () => getSpecialtiesList());

export { useGetUserProfile, createUserProfile };
